import CreateButton from "../components/CreateButton"
import { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import HeaderFooterLayout from '../components/layouts/HeaderFooterLayout';
import Table from '../components/Table';
import Button from '../components/Button';
import Card from '../components/cards/Card';
import StatusBadge from '../components/StatusBadge';
import Pagination from '../components/Pagination';
import EmptyContent from '../components/EmptyContent';
import styles from './Surveys.module.css';

export default function Surveys() {
    const [surveys, setSurveys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [page, setPage] = useState(0);
    const [total, setTotal] = useState(0);
    const [reload, setReload] = useState(0);
    const per = 10;
    const navigate = useNavigate();
    useEffect(() => {
        let cancelled = false;
        setLoading(true); setError('');
        api.get(`/admin/surveys?page=${page}&per=${per}`).then(data => {
            if (!cancelled) { setSurveys(data.surveys); setTotal(data.count); }
        }).catch(() => { if (!cancelled) setError('Impossibile caricare i questionari.'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [page, reload]);
    const statuses = { public: ['Pubblico', 'var(--sf-green)'], draft: ['Bozza', 'var(--sf-grey)'], hidden: ['Nascosto', 'var(--sf-red)'] };
    return <HeaderFooterLayout><HelmetProvider><Helmet><title>Questionari</title></Helmet></HelmetProvider>
        <div className={styles.container}><main className={styles.page}>
            <header className={styles.header}><div><h1>Questionari</h1><p>Gestisci i questionari e consulta le risposte dei partecipanti.</p></div><CreateButton onClick={() => navigate('/surveys/create/editor')}>Crea questionario</CreateButton></header>
            <Card appearance="modern" integratedTable title="Elenco questionari" actions={<span className={styles.resultCount}>{loading ? 'Caricamento…' : `${total} questionari`}</span>}>
                {error ? <div className={styles.error} role="alert">{error} <Button appearance="text" onClick={() => setReload(value => value + 1)}>Riprova</Button></div> : <>
                    <Table appearance="minimal" loading={loading} loadingN={5} style={{ border: 0, borderRadius: 0, marginTop: 0 }} onRowClick={row => navigate(`/surveys/${row.id}`)} columns={[
                        { key: 'title', label: 'Questionario', type: 'custom', wrap: true },
                        { key: 'created_at', label: 'Data di creazione', type: 'date' },
                        { key: 'completed', label: 'Compilazioni', type: 'number' },
                        { key: 'status', label: 'Stato', type: 'custom' },
                        { key: 'actions', label: 'Azioni', type: 'custom', handleClick: true },
                    ]} elements={surveys.map(s => ({ ...s,
                        title: { value: s.title, type: 'string', component: <Link className={styles.titleLink} to={`/surveys/${s.id}`} onClick={event => event.stopPropagation()}>{s.title || 'Questionario senza titolo'}</Link> },
                        completed: s.users_survey?.length ?? 0,
                        status: { value: s.status, type: 'string', component: <StatusBadge appearance="soft" label={statuses[s.status]?.[0] || s.status || '—'} color={statuses[s.status]?.[1] || 'var(--sf-grey)'} /> },
                        actions: <Link className={styles.editLink} to={`/surveys/${s.id}/editor`} aria-label={`Modifica ${s.title}`} onClick={event => event.stopPropagation()}>Modifica</Link>,
                    }))} />
                    {!loading && !surveys.length && <EmptyContent title="Nessun questionario" message="Crea un questionario per raccogliere le risposte dei partecipanti." />}
                </>}
                <div className={styles.pagination}><Pagination page={page} total={total} per={per} loading={loading} onChange={setPage} /></div>
            </Card>
        </main></div>
    </HeaderFooterLayout>;
}
